
const checkIsFeedback = (incident) => {
  return !!incident && incident.feedback && incident.feedback === true
}

export default checkIsFeedback